/* eslint-disable unicorn/no-array-reduce */
import { isEmpty } from 'remeda'

interface FormatRowProps {
  size: string | number
  count: number
  firstIndex: number
  lastIndex: number
}

export const formatRow = (row: (string | number)[]) =>
  row.reduce<FormatRowProps[]>((accumulator, current, index) => {
    const rowIndex = accumulator.findIndex(({ size }) => size === current)

    if (isEmpty(accumulator) || rowIndex === -1) {
      return [
        ...accumulator,
        {
          size: current,
          count: 1,
          firstIndex: index,
          lastIndex: index,
        },
      ]
    }

    accumulator[rowIndex] = {
      ...accumulator[rowIndex],
      count: accumulator[rowIndex].count + 1,
      lastIndex: index,
    }

    return accumulator
  }, [])
